"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9463],{

/***/ 84510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const QuadrilateroVerde = _ref => {
  let {
    color,
    flip,
    w,
    h
  } = _ref;
  const width = w || 372;
  const height = h || 346;
  const directionStyle = flip ? `scale(-1, 1) translate(-${width}, 0)` : '';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: "Quadrilatero verde"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
      id: "greenBackground",
      transform: directionStyle,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        fill: color || '#1f855f',
        id: "svg_1",
        d: `
        m 0,10
        c 0,-5 5,-10 11,-10
        l ${width - 22},0
        c 6,0 11,4 11,10
        l -45,${height - 20}
        c 0,5 -5,10 -11,10
        l -${width - 68},0
        c -6,0 -11,-4 -11,-10
        `,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (QuadrilateroVerde);

/***/ }),

/***/ 19463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49801);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84232);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72509);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3382);
/* harmony import */ var public_images_quadrilatero_verde__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84510);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);









const BeforeNltSection = _ref => {
  let {
    image,
    imageAlt,
    title,
    items,
    href,
    action,
    actionTitle,
    footer
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .VStack */ .gC, {
    align: "stretch",
    overflow: "hidden",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      bg: "baseWhite",
      p: "l",
      pt: "xxl",
      pb: "20rem",
      pos: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        mb: "7",
        fontSize: "1.25rem",
        lineHeight: "1.938rem",
        color: "baseDark",
        textAlign: "center",
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        items: items
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Medium",
        fontSize: ".75rem",
        lineHeight: "15.6px",
        letterSpacing: "0.4px",
        textAlign: "left",
        paddingTop: "l",
        children: footer
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        position: "relative",
        mt: "8",
        mx: "-6",
        textAlign: "left",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
          position: "absolute",
          h: "17.25rem",
          right: "-3",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(public_images_quadrilatero_verde__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            flip: true,
            color: "#2ec58d",
            h: 218,
            w: 172
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
          position: "absolute",
          top: "calc(50% + 18px)",
          left: "5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: image,
            alt: imageAlt,
            width: "364",
            height: "190",
            objectFit: "contain",
            loading: "lazy",
            decoding: "async"
          }), href && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            fontFamily: "Montserrat-Medium",
            fontSize: "1rem",
            color: "baseDark",
            href: href,
            title: actionTitle,
            display: "inline-block",
            paddingTop: "var(--cp-space-s)",
            children: [action, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* .ArrowForwardIcon */ .mr, {})]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BeforeNltSection);

/***/ }),

/***/ 72509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children", "href", "title", "target", "color", "fontFamily", "fontSize", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const StylesLink = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-vy2q48-0"
})(["& svg{display:inline;}"]);

const TextLink = _ref => {
  let {
    children,
    href,
    title,
    target,
    color,
    fontFamily,
    fontSize,
    style
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StylesLink, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, _objectSpread(_objectSpread({
      color: color || 'baseWhite',
      title: title,
      target: target || '_self',
      fontFamily: fontFamily ? fontFamily : 'Montserrat-Medium',
      fontSize: fontSize ? fontSize : '1rem',
      letterSpacing: "0.3px",
      display: "inline",
      _hover: {
        textDecoration: 'none'
      }
    }, props), {}, {
      href: href,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TextLink);

/***/ }),

/***/ 84232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WithDescription; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/loader.ts
var loader = __webpack_require__(5349);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/uikit/Image/index.tsx





const CustomImage = _ref => {
  let {
    src,
    alt,
    className,
    layout,
    width,
    height,
    placeholder,
    lazy,
    decoding
  } = _ref;
  // Priority per immagini above-the-fold (non lazy)
  const isPriority = !lazy;

  if (layout !== 'fill' && width && height) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      (0,jsx_runtime.jsx)((image_default()), {
        loader: loader/* imageLoader */.X,
        alt: alt,
        src: src,
        className: className,
        layout: layout,
        width: width,
        height: height,
        placeholder: placeholder,
        priority: isPriority,
        loading: lazy ? 'lazy' : 'eager',
        decoding: decoding || 'async'
      })
    );
  }

  return (
    /*#__PURE__*/
    // @ts-ignore
    (0,jsx_runtime.jsx)((image_default()), {
      loader: loader/* imageLoader */.X,
      alt: alt,
      src: src,
      className: className,
      layout: "fill",
      placeholder: placeholder,
      objectFit: "contain",
      priority: isPriority,
      loading: lazy ? 'lazy' : 'eager',
      decoding: decoding || 'async'
    })
  );
};

/* harmony default export */ var Image = (CustomImage);
;// CONCATENATED MODULE: ./src/uikit/Lists/WithDescription.tsx






const ItemWithImage = /*#__PURE__*/styled_components_browser_esm["default"].div.withConfig({
  componentId: "sc-18b5dsf-0"
})(["display:flex;"]);
const Item = /*#__PURE__*/styled_components_browser_esm["default"].span.withConfig({
  componentId: "sc-18b5dsf-1"
})(["max-width:90%;display:inline;padding-left:0.5rem;"]);

const ListWithDescription = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
    columns: {
      base: 1,
      md: 2
    },
    spacing: "l",
    textAlign: "left",
    children: items.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemWithImage, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: item.icon,
        alt: "",
        layout: "fixed",
        height: "32px",
        width: "32px"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.25rem",
          letterSpacing: "0.57px",
          lineHeight: "26px",
          whiteSpace: "pre-wrap",
          textAlign: "left",
          children: item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          marginTop: "xs",
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          fontSize: ".75rem",
          lineHeight: "18px",
          letterSpacing: "0.4px",
          whiteSpace: "pre-wrap",
          textAlign: "left",
          children: item.description
        })]
      })]
    }, item.title))
  });
};

/* harmony default export */ var WithDescription = (ListWithDescription);

/***/ }),

/***/ 49801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const H2 = _ref => {
  let {
    children,
    color
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, _objectSpread(_objectSpread({
    as: "h2",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.5rem",
    lineHeight: "36px",
    textAlign: "left",
    color: color || 'baseWhite',
    whiteSpace: "pre-wrap"
  }, props), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (H2);

/***/ }),

/***/ 5349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; }
/* harmony export */ });
// @ts-ignore
const imageLoader = _ref => {
  let {
    src
  } = _ref;
  return src;
};

/***/ })

}]);